<script>
  document.body.style.zoom = "70%";
</script>
<!-- <script [src]="'https://maps.googleapis.com/maps/api/js?key=' + environment.googleMapsApiKey + '&libraries=places'"></script> -->
<body>
  <ng-template [ngIf]="isNavVisible">
    <nav-header *ngIf="!(sessionService.isExternalMap |async)"></nav-header>
  </ng-template>
  <router-outlet></router-outlet>
</body>
